import { ColorPicker as BaseColorPicker } from '@systemeio/ui'
import Option from '../../components/Option'
import { normalizeColor } from '@email-editor/ui'

type ColorPickerProps = {
  color: string
  label?: string
  update: (value: string) => void
}

function ColorPicker({
  color,
  label = 'settings_options.color_picker.label',
  update,
}: ColorPickerProps) {
  const resetTransparency = () => {
    update('#00000000')
  }

  return (
    <Option label={label}>
      <div className="flex items-center gap-3">
        <BaseColorPicker color={normalizeColor(color)} onChange={color => update(color)}>
          {() => (
            <div
              style={{ backgroundColor: color }}
              className="border-text-secondary/30 h-[30px] w-[30px] rounded-full border"
            />
          )}
        </BaseColorPicker>
        <i
          onClick={resetTransparency}
          className="fa fa-ban text-fill-primary hover:text-danger main-transition-colors cursor-pointer text-[30px]"
        />
      </div>
    </Option>
  )
}

export default ColorPicker
